import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments';
import { HttpClient } from '@angular/common/http';

const basePath = `${environment.apiBaseUrl}stripe-file`;

@Injectable({ providedIn: 'root' })
export class StripeFileApiClient {
  private readonly _http = inject(HttpClient);

  getInvoiceUrl(invoiceId: string) {
    return this._http.get(`${basePath}/invoice/${invoiceId}/url`, { responseType: 'text' });
  }
}
